import { Checkbox, Radio } from '@chakra-ui/react';
import React, { HTMLProps } from 'react';

const IndeterminateCheckbox = ({
  enableMultiRowSelection,
  indeterminate,
  checked,
  disabled,
  onChange,
}: { indeterminate?: boolean; enableMultiRowSelection?: boolean } & HTMLProps<HTMLDivElement>) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      {enableMultiRowSelection ? (
        <Checkbox
          size='lg'
          isIndeterminate={indeterminate}
          isChecked={checked}
          onChange={onChange}
          isDisabled={disabled}
        />
      ) : (
        <Radio size='lg' isChecked={checked} onChange={onChange} disabled={disabled} />
      )}
    </div>
  );
};

export default IndeterminateCheckbox;
